export default __webpack_public_path__ + "static/media/error.79ba2202.jpg";